import styled from "styled-components";

export const Status = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.style?.backgroundColor};
  text-align: center;
  width: 94%;
  border-radius: 10px;
  min-height: 22px;
  font-size: 13px;
  padding: 0px 8px;
`;
